import { ReactElement } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { frontendRoutes } from '../../Constants/constants';
import { SurveyNavigationState } from '../../types/navigation';

/**
 * Guards the registration verification steps (otp-verify, is-this-you,
 * text-verify). They all depend on the phone number captured in step 1, which
 * lives only in ephemeral Redux state. On a page refresh that state is gone, so
 * instead of rendering a broken step (a crash, or an endless Persona spinner)
 * we restart the flow at /phone-verify.
 */
export const VerificationGuard = ({ children }: { children: ReactElement }) => {
  const params = useParams<{ builder_name?: string }>();
  const location = useLocation<SurveyNavigationState | undefined>();
  const phoneNumber = useSelector((state: any) => state.phNumber?.phNumber?.phone);

  if (!phoneNumber) {
    return (
      <Redirect
        to={{
          pathname: frontendRoutes.phoneVerify(params.builder_name).path,
          state: location.state,
        }}
      />
    );
  }

  return children;
};
